import jxWindowEngine from '@/JxControls/JxWindowManager/JxWindowEngine';
import jxWindowManager from '@/JxControls/JxWindowManager/JxWindowManager.jsx';
import topicGroupEngine from './DashboardComponents/YourNotesTab/YourNotesGroupManager/TopicGroupEngine';
import attachmentEngine from './DashboardComponents/AttachmentStrip/AttachmentEngine';
import quotaEngine from '@/services/engines/QuotaEngine';
import userStateEngine2 from '@/controllers/UserState/UserStateEngine2';
import yourDataEngine from './DashboardComponents/YourDataTab/YourDataEngine';
import calendarEngine from '@/CalendarWidget/Core/CalendarEngine';
import yourNoteEngine from '@/services/engines/YourNoteEngine';
import groupNodeEngine from './DashboardComponents/YourNotesTab/Engines/GroupNodeEngine';
import searchEngine from './DashboardComponents/YourSearchTab/Core/SearchEngine';
import searchQueryEngine from './DashboardComponents/YourSearchTab/Core/SearchQueryEngine';
import userEngine from '@/controllers/User/UserEngine';
import logEngine from '@/services/engines/log/LogEngine';
import errorEngine from '@/components/shared/ErrorSnack/ErrorEngine';
import templateEngine from './DashboardComponents/TemplateEngine/TemplateEngine';
import bodyEditorEngine from '@/BodyEditorWidget/Core/BodyEditorEngine';
import formConfigEngine from '@/Widgets/FormBuilderWidget/Core/FormConfigEngine';
import csCodeTemplateEngine from '@/Widgets/CsCodeGenWidget/Core/CsCodeTemplateEngine';
import csCodeGenConfigEngine from '@/Widgets/CsCodeGenWidget/Core/CsCodeGenConfigEngine';
import umlNotesEngine from '@/UmlWorkspace/Core/UmlNotesEngine.js';
import outputMsgEngine from '@/Widgets/OutputMsgWidget/Core/OutputMsgEngine.js';
import cardDataEngine from '@/Widgets/DataPainterWidget/Core/CardDataEngine';
import userTypeEngine from './DashboardComponents/UserDefinedTypes/UserTypeEngine';
import umlPreviewEngine from '@/UmlWorkspace/Core/Preview/UmlPreviewEngine';
import umlPkgLibEngine from '@/UmlWorkspace/UmlPkgLib/Core/UmlPkgLibEngine';
import fearGreedEngine from '@/Widgets/DataPainterWidget/FearGreedWidget/FearGreedEngine';
import cmcUsageEngine from '@/Widgets/DataPainterWidget/CmcUsageWidget/CmcUsageEngine';
import userSettingsEngine from '@/controllers/UserSettings/UserSettingsEngine';

/**
 * Engines with a generic, auth-independent bootup() — called once at app mount, order-independent.
 * userSettingsEngine is excluded — it must bootup before the token fetch, see PageContent.
 */
export const bootEngines = [
    jxWindowEngine,
    jxWindowManager,
    topicGroupEngine,
    attachmentEngine,
    quotaEngine,
    userStateEngine2,
    yourDataEngine,
    calendarEngine,
    yourNoteEngine,
    groupNodeEngine,
    searchEngine,
    searchQueryEngine,
    userEngine,
    logEngine,
    errorEngine,
    templateEngine,
    bodyEditorEngine,
    formConfigEngine,
    csCodeTemplateEngine,
    csCodeGenConfigEngine,
    umlNotesEngine,
    outputMsgEngine,
    cardDataEngine,
    userTypeEngine,
    umlPreviewEngine,
    umlPkgLibEngine,
    fearGreedEngine,
    cmcUsageEngine,
];

/**
 * User/tab-dependent fetch methods — called once auth + SignalR connection is confirmed,
 * see PageContent.checkSignalR's Promise.all.
 */
export const bootFetchers = [
    () => jxWindowEngine.fetchGeo(),
    () => formConfigEngine.fetchAll(),
    () => userTypeEngine.fetch(),
    () => umlNotesEngine.fetchAll(),
    () => umlPreviewEngine.fetchAll(),
    () => umlPkgLibEngine.fetchAll(),
    () => fearGreedEngine.fetch(),
    () => cmcUsageEngine.fetch(),
    () => userStateEngine2.fetchAll(),
    () => userEngine.fetchUser(),
    () => userSettingsEngine.fetchSettings(),
    () => templateEngine.fetchAll(),
    () => bodyEditorEngine.fetchStyles(),
];

/**
 * Engines cleared on PageContent unmount — jxWindowEngine/jxWindowManager included even
 * though they're also in bootEngines; clear() is idempotent-safe, order doesn't matter.
 */
export const unmountEngines = [
    groupNodeEngine,
    userEngine,
    jxWindowEngine,
    jxWindowManager,
];
